module.exports = __webpack_public_path__ + "static/media/sample_lmapprovedsob.aa845b22.csv";